import { apiClient } from "@/lib/api/client";
import type { SmartSearchResponse } from "@/features/smart-search/types";

export const getAuthenticatedSmartSearchResults = async (
  query: string,
  signal?: AbortSignal,
): Promise<SmartSearchResponse> => {
  const response = await apiClient.get<SmartSearchResponse>("/smart-search", {
    params: { q: query },
    signal,
  });

  return response.data;
};
